import BaseService from '../../BaseService'

export default class VerbrauchsstaetteService extends BaseService {

  constructor(id) {
    super(`gp/${id}/verbrauchsstaette`);
  }

}
